import React from 'react';
import QuoteButton from './QuoteButton';
import { AsButton, AsCheckbox } from '@adserve/adserve-react-components';
export const campaignPropertyColumnDefinition = (onQuoteClick, readOnly) => {
    const CustomCheck = (a) => {
        return <AsCheckbox data-id={a.data.id} onChange={onQuoteClick} checked={a.data.quote}></AsCheckbox>;
    };
    return [
        {
            displayOrder: 1,
            headerName: '',
            field: 'id',
            type: 'hidden',
            hideInColumnFilter: true
        },
        {
            displayOrder: 1,

            headerName: 'Actions',
            field: 'delete',
            type: 'action',
            width: 50,
            hideInColumnFilter: true,
            showInList: true,
            sortable: false
        },

        {
            displayOrder: 3,
            headerName: window.translate('User'),
            field: 'requestUserName',
            type: 'text',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 4,
            headerName: window.translate('Property Name'),
            field: 'propertyName',
            type: 'text',
            width: 'auto',
            hideInColumnFilter: true,
            showInList: true,
            sortable: true,
            sortOrder: '',
            isSticky: true
        },
        {
            displayOrder: 5,
            headerName: window.translate('Type'),
            field: 'propertyType',
            type: 'text',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 6,
            headerName: window.translate('First Episode'),
            field: 'firstEpisodeDate',
            type: 'date',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 7,
            headerName: window.translate('Last Episode'),
            field: 'lastEpisodeDate',
            type: 'date',
            width: 150,
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 8,
            headerName: window.translate('Episodes'),
            field: 'numberOfEpisode',
            type: 'number',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 9,
            headerName: window.translate('Book Price'),
            field: 'propertyPrice',
            type: 'currency',
            width: 'auto',
            showInList: true,
            sortable: false
        }
    ];
};
